import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Navbar, Nav, NavItem } from 'react-bootstrap';
import config from '../../configs/appConfig';

import Logo from './Logo';
import Login from './Login';
import Notification from '../ActivityFeed/Notification';
import NotificationDropdown from '../ActivityFeed/NotificationDropdown';
import * as defaultAvatar from '../../styles/images/defaultAvatar.png';

import Auth from '../../auth/auth';
import UserProfile from './UserProfile';

import './styles/Header.scss';

const auth = new Auth();

export default class Header extends Component {
  constructor(props) {
    super(props);

    this.state = {
      showLoginModal: false,
      showUserProfile: false,
      toolsPage: window.location.pathname.indexOf('/tools') > -1,
    };
  }

  componentDidMount() {
    window.addEventListener('OPEN_LOGIN_MODAL', this.toggleModal);
  }

  componentWillUnmount() {
    window.removeEventListener('OPEN_LOGIN_MODAL', this.toggleModal);
  }

  componentWillUpdate() {}

  toggleModal = e => {
    e && e.stopPropagation();
    e && e.nativeEvent && e.nativeEvent.stopImmediatePropagation();

    this.setState({
      showLoginModal: !this.state.showLoginModal,
    });
  };

  toggleUserProfile = e => {
    e && e.stopPropagation();
    e && e.nativeEvent && e.nativeEvent.stopImmediatePropagation();

    this.setState({
      showUserProfile: !this.state.showUserProfile,
    });
  };

  shouldRenderAvatar = () => {
    if (this.state.toolsPage) {
      return null;
    }

    if (auth.isAuthenticated()) {
      let avatarUrl =
          !auth.getUserAvatar() || auth.getUserAvatar() === 'undefined' ? defaultAvatar : auth.getUserAvatar(),
        maxWidth = auth.getUserAvatar() ? '40px' : '30px',
        border = auth.getUserAvatar() ? '0px' : '1px solid #ECECEC';

      return (
        <NavItem className='header-user-avatar' eventKey={2} onClick={this.toggleUserProfile} style={{ border }}>
          <img
            src={avatarUrl}
            alt='user avatar'
            className={'user-avatar' + (auth.getUserAvatar() ? '' : ' default')}
            style={{ maxWidth }}
          />

          {this.state.showUserProfile ? (
            <div>
              <div className='modal-back' onClick={this.toggleUserProfile} />
              <UserProfile user={this.props.user} setDarkMode={this.props.setDarkMode} logout={this.props.logout} />
            </div>
          ) : null}
        </NavItem>
      );
    } else {
      const isProd = true; //getQueryParamNoHash('test');

      return (
        isProd && (
          <NavItem className='login-btn' eventKey={2} onClick={this.toggleModal}>
            Login / Signup
          </NavItem>
        )
      );
    }
  };

  shouldRenderUploadButton = () => {
    if (this.state.toolsPage) {
      return null;
    }

    if (auth.isAuthenticated()) {
      return (
        <div className='upload-button raf-button' onClick={this.props.toggleUploadModal}>
          Upload
        </div>
      );
    }
  };

  renderNotification = props => {
    return (
      <div>
        <Notification {...props} activityGroup={props.activityGroup} />
      </div>
    );
  };

  render() {
    return (
      <div id='header'>
        <Navbar fixedTop className={'header-top-nav' + (this.state.toolsPage ? ' center-logo' : '')}>
          <Navbar.Header>
            <Logo />
          </Navbar.Header>
          {config.auth.require ? <Nav pullRight>{this.shouldRenderAvatar()}</Nav> : null}
          {this.props.user && !this.state.toolsPage && (
            <Nav pullRight>
              <NotificationDropdown notify right Group={props => this.renderNotification(props)} />
            </Nav>
          )}
          <Nav pullRight>{/*this.shouldRenderUploadButton()*/}</Nav>
        </Navbar>
        {this.state.showLoginModal ? (
          <div className='modal-back' onClick={this.toggleModal}>
            <Login setLoggedInUser={this.props.setLoggedInUser} firebase={this.props.firebase} />
          </div>
        ) : null}
      </div>
    );
  }
}

Header.propTypes = {
  user: PropTypes.object,
  firebase: PropTypes.object.isRequired,
  darkMode: PropTypes.bool,
};

Header.defaultProps = {
  user: {},
};
